import * as types from "../types/triggers.types";
import { 
  getList,
  patchEdit,
} from '../../services/triggers.service';
import { validationErrors } from "../../utils/Helpers";

export const listAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      await getList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        dispatch({
          type: types.SET_LIST_DATA,
          payload: res.data.data,
        });
      })
    } catch (e) {
      validationErrors(e)
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};

export const filterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_LIST_FILTER,
      payload: data,
    });
  };
};


export const patchAction = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({type: types.SET_LOADING_DATA, payload: true});
      return await patchEdit(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({type: types.SET_LOADING_DATA, payload: false});
    }
  };
};






